import {
  getZoomMeetings,
  getMeetingDetails,
  getPastMeetingDetails,
  getMeetingParticipants,
  getZoomJwtToken,
  createZoomMeeting,
  deleteZoomMeeting,
} from "@/services/zoom.service";
// initial state
const state = () => ({
  createZoomModel: {
    agenda: "Ders",
    duration: 60,
    pre_schedule: false,
    // schedule_for: "",
    // settings: {
    //   additional_data_center_regions: ["TY"],
    //   allow_multiple_devices: true,
    //   alternative_hosts: "jchill@example.com;thill@example.com",
    //   alternative_hosts_email_notification: true,
    //   approval_type: 2,
    //   approved_or_denied_countries_or_regions: {
    //     approved_list: ["CX"],
    //     denied_list: ["CA"],
    //     enable: true,
    //     method: "approve",
    //   },
    //   audio: "telephony",
    //   authentication_domains: "example.com",
    //   authentication_exception: [
    //     {
    //       email: "jchill@example.com",
    //       name: "Jill Chill",
    //     },
    //   ],
    //   authentication_option: "signIn_D8cJuqWVQ623CI4Q8yQK0Q",
    //   auto_recording: "cloud",
    //   breakout_room: {
    //     enable: true,
    //     rooms: [
    //       {
    //         name: "room1",
    //         participants: ["jchill@example.com"],
    //       },
    //     ],
    //   },
    //   calendar_type: 1,
    //   close_registration: false,
    //   cn_meeting: false,
    //   contact_email: "jchill@example.com",
    //   contact_name: "Jill Chill",
    //   email_notification: true,
    //   encryption_type: "enhanced_encryption",
    //   focus_mode: true,
    //   global_dial_in_countries: ["US"],
    //   host_video: true,
    //   in_meeting: false,
    //   jbh_time: 0,
    //   join_before_host: false,
    //   language_interpretation: {
    //     enable: true,
    //     interpreters: [
    //       {
    //         email: "interpreter@example.com",
    //         languages: "US,FR",
    //       },
    //     ],
    //   },
    //   meeting_authentication: true,
    //   meeting_invitees: [
    //     {
    //       email: "jchill@example.com",
    //     },
    //   ],
    //   mute_upon_entry: false,
    //   participant_video: false,
    //   private_meeting: false,
    //   registrants_confirmation_email: true,
    //   registrants_email_notification: true,
    //   registration_type: 1,
    //   show_share_button: true,
    //   use_pmi: false,
    //   waiting_room: false,
    //   watermark: false,
    // },
     start_time: null,
    // template_id: "Dv4YdINdTk+Z5RToadh5ug==",
    timezone: "",
    topic: "Konu",
    // tracking_fields: [
    //   {
    //     field: "field1",
    //     value: "value1",
    //   },
    // ],
    type: 2,
  },
});

// mutations
const mutations = {};

// actions
const actions = {
  async loadZoomMeetings() {
    return await getZoomMeetings().then((response) => {
      let data = response.data.data;

      data.map((meeting, index) => {
        meeting.index = index + 1;
      });

      return data;
    });
  },

  async loadMeetingDetails(vuexContext, meetingId) {
    return await getMeetingDetails(meetingId).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async loadMeetingParticipants(vuexContext, meetingId) {
    return await getMeetingParticipants(meetingId).then((response) => {
      let data = response.data.data;
      data.map((item, index) => {
        item.index = index + 1;
      });
      return data;
    });
  },

  async loadPastMeetingDetails(vuexContext, meetingId) {
    return await getPastMeetingDetails(meetingId).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async loadZoomJwtToken() {
    return await getZoomJwtToken().then((response) => {
      let data = response.data.data.token;
      return data;
    });
  },

  async createZoomMeeting(vuexContext, request) {
    return await createZoomMeeting(request).then((response) => {
      let data = response.data.data;
      return data;
    });
  },

  async deleteZoomMeeting(vuexContext, request) {
    return await deleteZoomMeeting(request).then((response) => {
      let data = response.data.data;
      return data;
    });
  },
};

// getters
const getters = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
